var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 49",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.93 23.2c0 6.69-5.42 12.11-12.11 12.11-6.69 0-12.11-5.42-12.11-12.11 0-6.69 5.42-12.11 12.11-12.11 6.69 0 12.11 5.42 12.11 12.11Zm-3.98 14.73a16.773 16.773 0 0 1-8.13 2.09C13.53 40.02 6 32.49 6 23.2S13.53 6.38 22.82 6.38s16.82 7.53 16.82 16.82c0 4.64-1.88 8.85-4.93 11.89l6.62 6.62A2.354 2.354 0 1 1 38 45.04l-6.76-6.76c-.11-.11-.21-.23-.3-.36l.01.01Z"
})));
export default SvgSearch;